export const icons = {
  calendar: {
    path: '../../../assets/new-icons/calendar-icon.svg',
    alt: 'Calendar icon'
  },
  logIn: {
    path: '../../../assets/new-icons/log-in-icon.svg',
    alt: 'Log in icon'
  },
  logoK: {
    path: '../../../assets/new-icons/k-kashio-icon.svg',
    alt: 'Logo Kashio'
  },
  logoName: {
    path: '../../../assets/new-icons/logo-name.svg',
    alt: 'Logo Kashio icon'
  },
  menu: {
    path: '../../../assets/new-icons/menu-icon.svg',
    alt: 'Menu icon'
  },
  user: {
    path: '../../../assets/new-icons/user-icon.svg',
    alt: 'User icon'
  },
  user_v2: {
    path: '../../../assets/new-icons/user-icon-v2.svg',
    alt: 'User icon'
  },
  filterLines: {
    path: '../../../assets/new-icons/filter-lines.svg',
    alt: 'Filter lines icon'
  },
  fileText: {
    path: '../../../assets/new-icons/file-text-icon.svg',
    alt: 'File text icon'
  },
  editFirstVersion: {
    path: '../../../assets/new-icons/edit-icon.svg',
    alt: 'Edit icon'
  },
  edit: {
    path: '../../../assets/new-icons/edit-2-icon.svg',
    alt: 'Edit icon'
  },
  copy: {
    path: '../../../assets/new-icons/copy-icon.svg',
    alt: 'Copy icon'
  },
  xCircle: {
    path: '../../../assets/new-icons/x-circle-icon.svg',
    alt: 'X circle icon'
  },
  dotsVertical: {
    path: '../../../assets/new-icons/dots-vertical-icon.svg',
    alt: 'Vertical dots'
  },
  download: {
    path: '../../../assets/new-icons/new-download-icon.svg',
    alt: 'Download icon'
  },
  plus: {
    path: '../../../assets/new-icons/plus-icon.svg',
    alt: 'Plus icon'
  },
  bluePlus: {
    path: '../../../assets/new-icons/blue-plus-icon.svg',
    alt: 'Blue plus icon'
  },
  search: {
    path: '../../../assets/new-icons/new-search-icon.svg',
    alt: 'Search icon'
  },
  xSquare: {
    path: '../../../assets/img/import-process/x-square.svg',
    alt: 'X square icon'
  },
  unlock: {
    path: '../../../assets/img/import-process/unlock.svg',
    alt: 'Unlock icon'
  },
  check: {
    path: '../../../assets/img/import-process/check.svg',
    alt: 'Check icon'
  },
  check_v2: {
    path: '../../../assets/new-icons/check-icon-v2.svg',
    alt: 'Check icon'
  },
  fileMinus: {
    path: '../../../assets/img/import-process/file-minus.svg',
    alt: 'File minus icon'
  },
  frown: {
    path: '../../../assets/img/import-process/frown.svg',
    alt: 'Frown icon'
  },
  loader: {
    path: '../../../assets/img/import-process/loader.svg',
    alt: 'Loader icon'
  },
  question: {
    path: '../../../assets/img/import-process/question-symbol.svg',
    alt: 'Question symbol icon'
  },
  dropMenu:{
    path: '../../../assets/new-icons/drop-down-menu.svg',
    alt: 'Dropdown menu'
  },
  buttonStatus:{
    path: '../../../assets/new-icons/button-status-icon.svg',
    alt: 'Button status icon'
  },
  mail:{
    path: '../../../assets/new-icons/mail-icon.svg',
    alt: 'Mail icon'
  },
  chevronDown:{
    path: '../../../assets/new-icons/chevron-down-icon.svg',
    alt: 'Chevron down icon'
  },
  alertCircle:{
    path: '../../../assets/new-icons/alert-circle-icon.svg',
    alt: 'Alert circle icon'
  },
  iconSettings:{
    path: '../../../assets/new-icons/settings-icon-version-2.svg',
    alt: 'Settings icon'
  },
  iconClose:{
    path: '../../../assets/new-icons/close-icon.svg',
    alt: 'Close icon'
  }
};

export const checkOutlineIcon = {
  path: '../../../assets/new-icons/check-outline-icon.svg',
  alt: 'Check outline icon'
};


export const arrowNarrowIcon = {
  path: '../../../assets/new-icons/arrow-narrow-icon.svg',
  alt: 'Arrow narrow icon'
};

export const txtFileIcon = {
  path: '../../../assets/new-icons/txt-file-icon.svg',
  alt: 'Txt file icon'
};

export const xlsFileIcon = {
  path: '../../../assets/new-icons/xls-file-icon.svg',
  alt: 'Xls file icon'
};

export const xlsxFileIcon = {
  path: '../../../assets/new-icons/xlsx-file-icon.svg',
  alt: 'Xlsx file icon'
};

export const csvFileIcon = {
  path: '../../../assets/new-icons/csv-file-icon.svg',
  alt: 'Csv file icon'
};

export const calendarIcon = {
  path: '../../../assets/new-icons/calendar-icon.svg',
  alt: 'Calendar icon'
};

export const logInIcon = {
  path: '../../../assets/new-icons/log-in-icon.svg',
  alt: 'Log in icon'
};

export const logoKIcon = {
  path: '../../../assets/new-icons/k-kashio-icon.svg',
  alt: 'Logo Kashio'
};

export const logoNameIcon = {
  path: '../../../assets/new-icons/logo-name.svg',
  alt: 'Logo Kashio icon'
};

export const menuIcon = {
  path: '../../../assets/new-icons/menu-icon.svg',
  alt: 'Menu icon'
};

export const userIcon = {
  path: '../../../assets/new-icons/user-icon.svg',
  alt: 'User icon'
};

export const userV2Icon = {
  path: '../../../assets/new-icons/user-icon-v2.svg',
  alt: 'User icon'
};

export const filterLinesIcon = {
  path: '../../../assets/new-icons/filter-lines.svg',
  alt: 'Filter lines icon'
};

export const fileTextIcon = {
  path: '../../../assets/new-icons/file-text-icon.svg',
  alt: 'File text icon'
};

export const editFirstVersionIcon = {
  path: '../../../assets/new-icons/edit-icon.svg',
  alt: 'Edit icon'
};

export const editIcon = {
  path: '../../../assets/new-icons/edit-2-icon.svg',
  alt: 'Edit icon'
};

export const copyIcon = {
  path: '../../../assets/new-icons/copy-icon.svg',
  alt: 'Copy icon'
};

export const xCircleIcon = {
  path: '../../../assets/new-icons/x-circle-icon.svg',
  alt: 'X circle icon'
};

export const dotsVerticalIcon = {
  path: '../../../assets/new-icons/dots-vertical-icon.svg',
  alt: 'Vertical dots'
};

export const downloadIcon = {
  path: '../../../assets/new-icons/new-download-icon.svg',
  alt: 'Download icon'
};

export const plusIcon = {
  path: '../../../assets/new-icons/plus-icon.svg',
  alt: 'Plus icon'
};

export const bluePlusIcon = {
  path: '../../../assets/new-icons/blue-plus-icon.svg',
  alt: 'Blue plus icon'
};

export const searchIcon = {
  path: '../../../assets/new-icons/new-search-icon.svg',
  alt: 'Search icon'
};

export const xSquareIcon = {
  path: '../../../assets/img/import-process/x-square.svg',
  alt: 'X square icon'
};

export const unlockIcon = {
  path: '../../../assets/img/import-process/unlock.svg',
  alt: 'Unlock icon'
};

export const checkIcon = {
  path: '../../../assets/img/import-process/check.svg',
  alt: 'Check icon'
};

export const checkV2Icon = {
  path: '../../../assets/new-icons/check-icon-v2.svg',
  alt: 'Check icon'
};

export const fileMinusIcon = {
  path: '../../../assets/img/import-process/file-minus.svg',
  alt: 'File minus icon'
};

export const frownIcon = {
  path: '../../../assets/img/import-process/frown.svg',
  alt: 'Frown icon'
};

export const loaderIcon = {
  path: '../../../assets/img/import-process/loader.svg',
  alt: 'Loader icon'
};

export const questionIcon = {
  path: '../../../assets/img/import-process/question-symbol.svg',
  alt: 'Question symbol icon'
};

export const dropMenuIcon = {
  path: '../../../assets/new-icons/drop-down-menu.svg',
  alt: 'Dropdown menu'
};

export const buttonStatusIcon = {
  path: '../../../assets/new-icons/button-status-icon.svg',
  alt: 'Button status icon'
};

export const mailIcon = {
  path: '../../../assets/new-icons/mail-icon.svg',
  alt: 'Mail icon'
};

export const chevronDownIcon = {
  path: '../../../assets/new-icons/chevron-down-icon.svg',
  alt: 'Chevron down icon'
};

export const alertCircleIcon = {
  path: '../../../assets/new-icons/alert-circle-icon.svg',
  alt: 'Alert circle icon'
};

export const xIcon = {
  path: '../../../assets/new-icons/x-close-icon.svg',
  alt: 'X close icon'
};

export const messageNotificationCircle = {
  path: '../../../assets/new-icons/message-notification-circle-icon.svg',
  alt: 'Message notification icon'
};

export const uploadArrowIcon = {
  path: '../../../assets/new-icons/upload-arrow-icon.svg',
  alt: 'Upload arrow icon'
};
